import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PDF from "../assets/resume.pdf"

const generateSocials = (data) => {
  data = data.filter((data) => data.isIcon);

  return data.map((item, index) => {
    return (
      <a href={item.name} key={index}>
        <FontAwesomeIcon icon={item.icon} className="fa" />
      </a>
    );
  });
};

const generateButtons = (data) => {
  data = data.filter((data) => !data.isIcon);
  return data.map((item, index) => {
    return (
      <span className="resume-box" key={index}>
        <a href={PDF} target="_blank" rel="noopener noreferrer">
          <span className="resume-link strike">{item.displayMethod}</span>
        </a>
      </span>
    );
  });
};

function SplitLeft(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    let temp =
      props &&
      props.info.filter(
        (data) =>
          data.display &&
          data.hasOwnProperty("displayMethod") &&
          data.displayMethod.length > 0
      );

    temp.map((data) => {
      data.icon = data.displayMethod.split(", ");
      return null;
    });

    setData(temp);
  }, [props]);

  return (
    <div className="left">
      <div className="bg-img"></div>
      <div className="left-inner">
        <div className="info">
          <h2 className="name">Hey, I'm Hrithvik</h2>
          <div className="subtext">I love building things and learning new technologies</div>
          <div className="jobStatus">
            <b>Computer Science @ University of Waterloo</b>
          </div>
          <div className="social-links">{generateSocials(data)}</div>
          <div className="social-links">{generateButtons(data)}</div>
        </div>
      </div>
    </div>
  );
}

export default SplitLeft;
